<template>
  <div class="upload-xml__container">
    <div class="ux-dropzone">
      <div
        v-if="uploadStatus === 'STATUS_UPLOADING'"
        class="ux-dropzone__wrapper sending"
      >
        <img
          src="/static/images/icon-upload-sending.svg"
          alt
          class="icon"
        >
        <p class="ux-dropzone__text">
          Realizando upload do arquivo…
        </p>
        <loading />
        <a
          class="ux-dropzone__cancel-link"
          @click="closeModalContainer"
        >Cancelar</a>
      </div>
      <div
        v-else
        class="ux-dropzone__wrapper"
      >
        <div class="ux-dropzone__content">
          <file-upload
            ref="upload"
            v-model="files"
            post-action="/upload/post"
            :multiple="false"
            :drop="true"
            :drop-directory="true"
            :accept="accept"
            @input-file="onFileDropped"
          >
            <div class="ux-dropzone__box">
              <img
                class="icon"
                src="/static/images/icon-upload-xml.svg"
                alt="Ícone Upload de arquivo"
              >

              <p class="ux-dropzone__text dropzone_label">
                Arraste e solte o arquivo aqui, ou
              </p>
              <form id="xmlParentFile">
                <input
                  id="xmlUpload"
                  type="file"
                  class="hide-input"
                  required
                  accept=".xml"
                  name="xmlUpload"
                  @change="onFileChange"
                >
              </form>
              <label
                id="mod_btnChooseFile"
                for="xmlUpload"
                class="btn btn-nonenary"
                @click="setUploadStatusMessage(null)"
              >
                SELECIONE O ARQUIVO
              </label>
              <a
                id="mod_btnFileCancel"
                class="ux-dropzone__cancel-link"
                @click="closeModalContainer"
              > Cancelar </a>
            </div>
          </file-upload>
        </div>
      </div>
      <div
        v-if="uploadStatusMessage"
        id="errorMessage"
        class="error-message"
      >
        <div class="error-message__message">
          <md-icon>error_outline</md-icon>
          {{ uploadStatusMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import store from '../../store/index'
import FileUpload from 'vue-upload-component'

export default {
  name: 'UploadXml',
  components: {
    FileUpload
  },
  data() {
    return {
      files: [],
      accept: 'text/xml, application/xml, .xml',
      uploadData: {
        file: []
      }
    }
  },
  methods: {
    ...mapActions(['setUploadStatusMessage']),
    ...mapActions(['uploadFileXml']),
    closeModalContainer() {
      this.$emit('closeModalContainer')
    },
    onFileDropped(data) {
      console.log('data dropped -->', data.file.type)
      if (!data) return
      if (data.file.type !== 'text/xml' && data.file.type !== 'application/xml') {
        this.uploadData.file = null
        store.dispatch('setUploadStatusMessage', 'Formato de arquivo inválido.')
        return
      }

      this.setUploadStatusMessage(null)
      this.uploadData.file = data.file
      this.uploadFileXml(this.uploadData.file)
    },
    onFileChange(e) {
      console.log('data changed -->', e.target.files[0])
      console.log('file type', e.target.files[0].type)
      this.setUploadStatusMessage(null)
      this.uploadData.file = e.target.files[0] || e.dataTransfer.files[0]
      this.uploadFileXml(this.uploadData.file)
      let parent = document.getElementById('xmlParentFile')
      parent.reset()

      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Importação de XML',
        action: 'Selecione o Arquivo',
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    }
  },
  computed: {
    ...mapGetters(['profile']),
    ...mapGetters(['uploadStatus']),
    ...mapGetters(['uploadStatusMessage'])
  }
}
</script>

<style lang="scss">
.upload-xml__container {
  position: relative;
  height: 380px;

  .ux-dropzone {
    width: 100%;
    height: 100%;
    position: relative;

    &__text {
      font-size: 15px;
      margin: 16px 0 17px;
      display: block;
      color: rgba(96, 96, 96, 0.87);

      @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        margin: 14px 0 16px;
      }
    }

    &__cancel-link:not(.md-button) {
      display: block;
      font-size: 13px;
      font-weight: 500;
      letter-spacing: normal;
      text-align: center;
      color: rgba(96, 96, 96, 0.87);
      text-decoration: underline;
      margin: 37px 0 10px;
      cursor: pointer;
      z-index: 1050;

      @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        margin-top: 37px;
      }

      &:hover {
        color: #000;
      }
    }

    &__wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .icon {
        margin: 52px 0 8px;
        height: 106px;
      }

      &.sending {
        .icon {
          margin: 69px 0 15px;
        }

        .file-dropzone__text {
          margin-bottom: 15px;
        }

        .file-dropzone__cancel-link:not(.md-button) {
          margin-top: 29px;
          cursor: pointer;
        }
      }
    }

    &__content {
      width: calc(100% - 40px);
      padding: 10px;
      background-color: #ebebeb;

      .file-uploads {
        width: 100%;
      }
    }

    .file-dropzone__wrapper {
      .dropzone_label {
        color: rgba(96, 96, 96, 0.87);
      }
    }

    &__box {
      display: flex;
      flex-direction: column;
      align-items: center;
      border: dashed 1px #929292;
      width: 100%;
      height: 100%;
    }

    &__attachment {
      width: 100%;
      display: flex;
      justify-content: space-between;
      min-height: 60px;
      align-items: center;
      padding: 15px;
      background: #ffffff;
      border: 1px solid #ebebeb;
      box-shadow: 0px 1px 3px rgba(121, 121, 121, 0.12);
      border-radius: 3px;
      margin-top: 20px;

      span {
        font-size: 12px;
        flex-grow: 1;
        margin: 10px;
        text-transform: uppercase;
        font-weight: 700;
        color: #7a7a7a;
      }

      img {
        width: 16px;
      }

      button {
        background: #7f1a54;
        border: none;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 19px;
        }
      }
    }

    &__form {
      display: flex;
      flex-direction: column;
      margin-top: 30px;
    }

    &__actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 40px;

      button {
        width: 161px;
        border-radius: 3px;
        text-transform: uppercase;
      }
    }

    &__cancel {
      background: #fff;
      border: 1px solid #7f1a54;
      color: #7f1a54;
    }
  }
}
.dashboard.modals .md-dialog-content {
  padding: 0 8px 8px;
}

#mod_btnXmlChooseFile {
  width: 253px;
  text-align: center;
  padding: 12px;
}

.error-message {
  position: absolute;
  top: 0;
  left: 0;
  padding: 10px 20px;
  width: 100%;
  opacity: 0.85;
  background-color: #7f1a54;
  font-size: 14px;
  letter-spacing: -0.2px;
  color: rgba(255, 255, 255, 0.87);
  height: auto;
  display: flex;
  align-items: center;

  .md-icon {
    margin: 0 4px 0 0;
    flex-grow: 0;
  }

  &__message {
    text-overflow: ellipsis;
    white-space: normal;
    display: block;
    overflow: hidden;
    width: 100%;
    text-align: center;
  }
}
</style>
